export default {
  //导航栏
  barmessage: {
    Home: 'বাড়ি',
    data: 'তথ্য পুনরুদ্ধার',
    About: 'আমাদের সম্পর্কে',
    productService: 'পণ্য সেবা',
    cases: 'কেস',
    news: 'সংবাদ',
    contactUs: 'আমাদের সাথে যোগাযোগ করুন',
    login: 'অবতরণ',
    report: 'তথ্য পরিসংখ্যান',
    LOGOtitle: 'সিপিইওএস ইন্টারন্যাশনাল ডেটা নোড',
    LOGOtitleregion: 'বাংলাদেশে'
  },

  queryboardmessage: { //查询面板
    polygon: 'বহুভুজ',
    nominatim: 'স্থানের নাম লিখুন',
    producttype: 'পণ্য গ্রেড',
    cloud: 'ক্লাউড কভার <',
    sensing: 'শুটিংয়ের তারিখ',
    satellite: 'স্যাটেলাইট সেন্সর',
    drawpolygon: 'বহুভুজ আঁকুন',
    drawrectangle: 'একটি আয়তক্ষেত্র আঁকুন',
    clear: 'জোনের অবস্থা পরিষ্কার করুন',
    query: 'তথ্য পুনরুদ্ধার',
    cart: 'গাড়ী দেখান/লুকিয়ে রাখুন',
    togglebutton: 'কোয়েরি প্যানেলটি টগল করে',
    uploadfailed: 'অসমর্থিত ডেটা ফরম্যাট',
    uploadsuccessed: 'ভেক্টর ডেটা সফলভাবে আপলোড করা হয়েছে',
    uploadbutton: 'ফাইল আপলোড করুন',
    uploadtitle: 'ভেক্টর আপলোড',
    upoladtip: 'এসএইচপি ফাইলগুলি সমর্থন করুন (.dbf, .shp, .prj তিন ধরণের ফাইল সহ .zip ফাইল, ফাইলের নাম অবশ্যই ইংরেজিতে হতে হবে)',
  },

  querymapmessage: { 
    lonlat: 'অক্ষাংশ দ্রাঘিমাংশ:',
    fullscreen: 'পূর্ণস্ক্রীণ',
    owslayername: 'বিশ্ব প্রশাসনিক বিভাগসমূহ',
    satellitelayername: 'উপগ্রহ চিত্র',
    worldlayername:'বিশ্ব প্রশাসনিক বিভাগসমূহ',
    boundlayername:'সীমা',
    labellayername:'বর্ণনা'
},

  resultlistmessage: { //查询结果面板,部分与购物车面板共用
    satellite: 'স্যাটেলাইট',
    sensingdate: 'শুটিংয়ের তারিখ',
    online: 'অনলাইন',
    offline: 'অফলাইন',
    display: 'Display {startindex} to {endindex} of {count} products',
    cartdisplay: 'Your Cart Contains { itemcount } products.',
    nofound: 'কোনও পণ্য পাওয়া যায়নি',
    viewdata: 'তথ্য বিবরণ দেখুন',
    zoomtodata: 'ডেটা সনাক্ত করুন',
    downloaddata: 'ডেটা ডাউনলোড',
    tocart: 'শপিং কার্টে ডেটা যোগ করা হয়েছে',
    removecart: 'গাড়ী থেকে অপসারণ করুন',
    offlinewaring: 'ডেটা অফলাইনে আছে',
  },
  userprofilemessage: {

    edit: 'ব্যবহারকারীর তথ্য সম্পাদনা করুন',
    logout: 'সাইন আউট করুন',
    function: 'বৈশিষ্ট্যগুলি উপলব্ধ',
    download: 'ডেটা ডাউনলোড',
    search: 'তথ্য পুনরুদ্ধার',
  },
  fpmessage: { // 忘记密码面板

    title: 'পাসওয়ার্ড ভুলে গেছেন',
    mess: 'অনুগ্রহ করে একটি লিঙ্ক পেতে এই ফর্মটি পূরণ করুন যা আপনাকে একটি নতুন পাসওয়ার্ড সেট করতে দেয়।',
    username: 'ব্যবহারকারীর নাম',
    usernameempty: 'ব্যবহারকারীর নাম খালি আছে',
    emailvalid: '"ইমেইল ফরম্যাট ভুল"',
    email: 'ইমেল',
    send: 'প্রেরণ',
    errtitle: 'পাসওয়ার্ড পুনরুদ্ধার ত্রুটি',
    errmess: 'এই ব্যবহারকারীর নাম/ইমেল সংমিশ্রণের জন্য ব্যবহারকারী খুঁজে পাওয়া যায়নি',
    succtitle: 'পাসওয়ার্ড পুনরুদ্ধার সফল হয়েছে',
    succmess: 'আপনার পাসওয়ার্ড পুনরায় সেট করার নির্দেশাবলী সহ আপনাকে একটি ইমেল পাঠানো হয়েছে।',
  },
  rpmessage: { //重置密码面板
    title: 'আপনার পাসওয়ার্ড পুনরায় সেট করুন',
    mess: 'আপনার পাসওয়ার্ড পুনরায় সেট করতে দয়া করে এই ফর্মটি পূরণ করুন।',
    passwdrule: 'পাসওয়ার্ড ক্ষেত্রগুলি কেবলমাত্র আলফানিউমেরিক অক্ষরগুলি প্লাস "!", "@", "#", "$", "%", "^", "&", "*"), "("+" "=" "" গ্রহণ করে। "_" "-"。 পাসওয়ার্ড ফিল্ডের ন্যূনতম দৈর্ঘ্য 8 অক্ষর।',
    passwd: 'পাসওয়ার্ড',
    emptypasswd: 'খালি পাসওয়ার্ড',
    passwdvalid: 'পাসওয়ার্ডটি খুব সংক্ষিপ্ত। ন্যূনতম 8 টি অক্ষর',
    confirmpasswdvalid: 'প্রবেশ করানো দুটি পাসওয়ার্ড মিলছে না ',
    confirmpasswd: 'পাসওয়ার্ড টি নিশ্চিত করুন',
    send: 'সংশোধন করুন',
    mbtitle1: 'পাসওয়ার্ড রিসেট',
    mbresult1: 'আপনার পাসওয়ার্ড পুনরায় সেট করা হয়েছে',
    mbresult2: 'পাসওয়ার্ড পুনরায় সেট করার সময় একটি ত্রুটি ঘটেছে',
    mbtitle2: 'পাসওয়ার্ড রিসেট ব্যর্থ হয়েছে',

  },
  registmessage: { //注册面板
    title: 'একটি নতুন ব্যবহারকারী নিবন্ধন করুন',
    header1: 'নিবন্ধিত ব্যবহারকারীরা বিনামূল্যে তাদের ডেটা পান',
    notice1: 'নীচের নিবন্ধন ফর্মটি পূরণ করার পরে, আপনি আপনার ইমেল ঠিকানা যাচাই করার জন্য একটি লিঙ্ক সহ একটি ইমেল পাবেন। এর পরে, আপনি ডেটা ডাউনলোড শুরু করতে পারেন। ব্যবহারকারীর নাম ক্ষেত্রটি কেবলমাত্র নিম্নকেস আলফানিউমেরিক অক্ষরগুলি প্লাস "", "-", এবং "_" গ্রহণ করে। পাসওয়ার্ড ক্ষেত্রগুলি কেবলমাত্র আলফানিউমেরিক অক্ষরগুলি প্লাস "!", "@", "#", "$", "%", "^", "&", "*"), "("+" "=" "" গ্রহণ করে। "_" "-"。 পাসওয়ার্ড ফিল্ডের ন্যূনতম দৈর্ঘ্য 8 অক্ষর',
    firstname: 'উপাধি',
    lastname: 'নাম',
    username: 'ব্যবহারকারীর নাম',
    passwd: 'পাসওয়ার্ড',
    confirmpasswd: 'পাসওয়ার্ড টি নিশ্চিত করুন',
    company: 'কোম্পানি/প্রতিষ্ঠানের নাম',
    email: 'ইমেইল ঠিকানা',
    confirmemail: 'ইমেল ঠিকানা নিশ্চিত করুন',
    emailcheck: 'ইমেল ঠিকানাটি বিকৃত হয়েছে',
    emailmatch: 'ইমেইল মিল নেই',
    selectdomain: 'একটি ক্ষেত্র নির্বাচন করুন',
    selectusage: 'একটি উদ্দেশ্য নির্বাচন করুন',
    selectcountry: 'একটি দেশ নির্বাচন করুন',
    register: 'নিবন্ধন করুন',
    shouquan: 'এই ওয়েবসাইটে নিবন্ধন করার মাধ্যমে, আপনি GF ডেটা ব্যবহারের শর্তাবলী গ্রহণ করেছেন বলে মনে করা হয়',
  },
  editprofilemessage: { //编辑用户信息面板
    title: 'User {username} profile',
    firstname: 'উপাধি',
    firstnameempty: 'শেষ নামটি পূরণ করা হয়নি',
    lastnameempty: 'কোনও নাম লেখা হয়নি',
    lastname: 'নাম',
    username: 'ব্যবহারকারীর নাম',
    passwd: 'পাসওয়ার্ড',
    confirmpasswd: 'পাসওয়ার্ড টি নিশ্চিত করুন',
    company: 'কোম্পানি/প্রতিষ্ঠানের নাম',
    email: 'ইমেইল ঠিকানা',
    confirmemail: 'ইমেল ঠিকানা নিশ্চিত করুন',
    emailcheck: 'ইমেল ঠিকানাটি বিকৃত হয়েছে',
    emailmatch: 'ইমেইল মিল নেই',
    selectdomain: 'একটি ক্ষেত্র নির্বাচন করুন',
    selectusage: 'একটি উদ্দেশ্য নির্বাচন করুন',
    selectcountry: 'একটি দেশ নির্বাচন করুন',
    passwordalerm1: 'অনুগ্রহ করে একটি পাসওয়ার্ড লিখুন',
    passwordalerm2: 'পাসওয়ার্ডটি খুব সংক্ষিপ্ত, ন্যূনতম 8 টি অক্ষর সহ',
    oldpasswd: 'পুরানো পাসওয়ার্ড লিখুন',
    savemodification: 'পরিবর্তনগুলি সংরক্ষণ করুন',
    passwdrule1: 'পাসওয়ার্ড ক্ষেত্রগুলি কেবলমাত্র আলফানিউমেরিক অক্ষরগুলি প্লাস "!", "@", "#", "$", "%", "^", "&", "*"), "("+" "=" "" গ্রহণ করে। "_" "-"。',
    passwdrule2: 'একটি পাসওয়ার্ড ফিল্ডের ন্যূনতম দৈর্ঘ্য 8 অক্ষর।',
    changepasswd: 'পাসওয়ার্ড পরিবর্তন করুন',
  },
  loginmessage: { //登陆面板
    title: 'আমাদের পরিষেবাগুলি অ্যাক্সেস করতে দয়া করে লগ ইন করুন...',
    username: 'ব্যবহারকারীর নাম',
    passwd: 'পাসওয়ার্ড',
    loginbutton: 'অবতরণ',
    signup: 'নিবন্ধন করুন',
    fpasswd: 'পাসওয়ার্ড ভুলে গেছেন?',
    passwderr: 'অনুগ্রহ করে একটি পাসওয়ার্ড লিখুন',
    loginsuccess: 'পাসওয়ার্ডটি খুব সংক্ষিপ্ত, ন্যূনতম 8 টি অক্ষর সহ',
    logoutsuccess: '"আপনি যে ব্যবহারকারীর নাম এবং পাসওয়ার্ড প্রবেশ করিয়েছেন তা মেলে না বা ব্যবহারকারী সক্রিয় নয়।',
    usernotice: 'দয়া করে লক্ষ্য করুন যে এই ব্যবহারকারী অ্যাকাউন্টটি CPEOS IDN সিস্টেমের অংশ এবং CPEOS ওয়েবসাইট সিস্টেম থেকে পৃথক। আপনাকে IDN সেবার জন্য একটি নির্ধারিত অ্যাকাউন্ট ব্যবহার করে লগইন করতে হবে। নতুন ব্যবহারকারীরা এখানে নিবন্ধন করতে পারেন এবং IDN সিস্টেম অপারেটরের ব্যবহারকারী দেশের পরীক্ষা পাস করতে হবে।',
    aboutuser:'*ব্যবহারকারী অ্যাকাউন্ট সম্পর্কে'
  },
  servicemessage: { //服务状态
    mess: 'লগইন সফল হয়েছে',
  },

  downloadmessage: { // তথ্য ডাউনলোড প্যানেলের তথ্য
    title: "তথ্যের বিস্তারিত তথ্য",
    downloadmess: "পণ্য ডাউনলোড করুন",
    closemess: "বন্ধ করুন",
    propertyname: 'সম্পত্তির নাম',
    propertyvalue: 'সম্পত্তির মূল্য',
    satellite: "স্যাটেলাইট:",
    sensor: "যন্ত্র:",
    dataid: "সনাক্তকারী:",
    image_start_time: "সেন্সিং তারিখ:",
    data_size: "আকার(জিবি):",
    orbit_num: "অরবিট সংখ্যা",
    st_astext: "ফুটপ্রিন্ট",
    productlevel: "প্রক্রিয়াকরণ স্তর",
    cloud_cover: "মেঘের আচ্ছাদন শতাংশ (%)",
    offline_flag: "অফলাইন"
},
  vdusermessage: { //激活用户
    title: '"পণ্য ডাউনলোড করুন"',
    success: 'ক্লোজ',
    failed: 'অ্যাকাউন্ট সফলভাবে সক্রিয় করা হয়েছে',
  },
  gf1message: {

  },
  gf2message: {
    p1mess: 'অ্যাকাউন্ট সক্রিয়করণ ব্যর্থ হয়েছে',
  },
  gf6message: {},
  reportmessage: {
    title: 'পরিষেবাটি পরিচালিত হওয়ার পর থেকে সমস্ত ডেটা সেন্টার পরিষেবাগুলির পরিসংখ্যান',
    RUsers: 'নিবন্ধিত ব্যবহারকারী',
    download: 'ব্যবহারকারী ডাউনলোড',
    Productsnum: 'প্রকাশিত পণ্যের সংখ্যা',
    Availability: 'গত মাসের প্রাপ্যতা',
  },
  indexmessage: {
    title1: 'অনুবাদ করা হলো "বাংলাদেশে CPEOS আন্তর্জাতিক ডেটা নোড"।',
    title2: 'অনুবাদ করা হলো "চীনা উপগ্রহ ডেটা এক্সেস বাংলাদেশের উপরে"।',
    title3: 'আরও অ্যাক্সেস'
  }
};